<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconClassName" />
  </svg>
</template>

<script>
export default {
  props: ["iconName", "className", "color"],
  computed: {
    iconClassName() {
      return `#${this.iconName}`;
    },
    svgClass() {
      if (this.className) {
        return `svg-icon ${this.className}`;
      }
      return `svg-icon`;
    },
  },
};
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  position: relative;
  fill: currentColor;
  vertical-align: -2px;
}
</style>



// WEBPACK FOOTER //
// src/components/svgIcon.vue